import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { Directive } from '@angular/core';

const CVR_CONTROL_WEIGHTS = [2, 7, 6, 5, 4, 3, 2, 1];

export function isValidCvrChecksum(value: string): boolean {
    if (!value) {
        return false;
    }

    const digitChars = value.replace(/\D/g, '');

    if (digitChars.length !== 8) {
        return false;
    }

    const digits = digitChars.split('').map(c => parseInt(c, 10));
    const sum = digits.reduce((total, digit, i) => total + digit * CVR_CONTROL_WEIGHTS[i], 0);

    return sum % 11 === 0;
}

@Directive({
    selector: '[appCvrValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: CvrValidatorDirective,
        multi: true
    }]

})
export class CvrValidatorDirective implements Validator {
    validate(control: AbstractControl): { [key: string]: any } | null {
        const value: string = control.value;

        if (value == null || value === '') {
            return null;
        }

        return isValidCvrChecksum(value) ? null : { 'invalidCvr': true };
    }
}
